import React, { useState, useEffect } from 'react';
import AnimatedTitle from '../ui/AnimatedTitle';

function SearchComponent({setSearchTerm}) {

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Access the input value by name
        const inputValue = e.target.elements['default-search'].value;
        setSearchTerm(inputValue);
    };

    return (
        <div className="bg-primary pt-32 py-16">
            <div className='container relative mx-auto w-full items-center justify-center flex flex-wrap text-center '>
                <AnimatedTitle text={'Discover the Best Lists in '} />
                <h2 className="mt-12 mx-2 text-3xl text-secondary w-full text-center">Learn how other users are using @maplistbot</h2>
                <form onSubmit={handleSubmit} className="w-90 px-6 pt-12">
                    <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only">Search</label>
                    <div className="relative">
                        <input
                            type="search"
                            id="default-search"
                            className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                            placeholder="Type your next destination..."
                            required
                        />
                        <button
                            type="submit"
                            className="w-12 flex items-center justify-center absolute top-0 right-0 p-2.5 text-sm font-medium h-full text-white bg-gray-50 rounded-r-lg"
                        >
                            <svg
                                className="w-4 h-4 text-primary"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                />
                            </svg>
                            <span className="sr-only">Search</span>
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
}

export default SearchComponent;